import Inputmask from 'inputmask';

$(document).ready(function () {
    const countries = require('countries-phone-masks');
    let html = "";
    countries.forEach(function (item, i) {
        html += `<li class="phone_item js__phone_item" data-name="${item.name}" data-mask="${item.mask}" data-code="${item.code}">
            <img alt="${item.name} flag" src="${item.flag}">
            <p class="name">${item.name}</p>
        </li>`
    });

    if ($('.js__phone_mask_list > li').length == 0) {
        $('.js__phone_mask_list').append(html)
        countryStart()
    }

    $(document).on('click', '.js__phone_mask', function () {
        $('.input_phone').toggleClass('active');
        $('.phone_list').toggleClass('show');
    });

    $('.js__search_phone').keyup(function () {
        var filter = $(this).val().trim();
        $('.js__phone_mask_list .name').each(function () {
            if ($(this).text().search(new RegExp(filter, "i")) < 0) {
                $(this).closest('.phone_item').hide();
            } else {
                $(this).closest('.phone_item').show()
            }
        });

        if (filter == "") {
            $(this).closest('.phone_item').show()
        }
    });

    $(document).on('click', '.js__phone_item', function () {
        $('.js__phone_item').removeClass('active');
        $(this).addClass('active');

        const mask = $(this).attr('data-mask').split('#').join('9');
        const code = $(this).attr('data-code');
        const src = $(this).find('img').attr('src');
        const alt = $(this).find('img').attr('alt');
        const name = $(this).find('.name').text().trim();

        $('.js__phone_mask img').attr({
            'src': src,
            'alt': alt
        })

        var selector = $('.input_input_phone');
        let im = "";
        if (name == 'Israel') {
            const code = '+972'; // замените это на ваш код страны
            const mask = `${code} ##-###-####`;

            $('.input_input_phone').attr({
                'placeholder': `${code} __-___-____`
            });

            Inputmask({
                mask: mask,
                definitions: {
                    '#': { // определение символа #
                        validator: "[0-9]", // можно задать другие условия валидации
                        cardinality: 1 // максимальная длина ввода
                    }
                }
            }).mask(selector);

            $('.input_input_phone').val(9);
        } else {
            $('.input_input_phone').attr({
                'placeholder': `${code} ${mask.split('9').join('_')}`
            });
            
            im = new Inputmask(`${code} ${mask}`);
            im.mask(selector);
        }

        $('.input_phone').removeClass('active');
        $('.phone_list').removeClass('show');
    });

    var selector_email = $('.input_email');
    var im_email = new Inputmask({
        mask: "*{1,20}[.*{1,20}][.*{1,20}][.*{1,20}]@*{1,20}[.*{2,6}][.*{1,2}]",
        greedy: false,
        onBeforePaste: function (pastedValue, opts) {
            pastedValue = pastedValue.toLowerCase();
            return pastedValue.replace("mailto:", "");
        },
        definitions: {
            '*': {
                validator: "[0-9A-Za-z!#$%&'*+/=?^_`{|}~\-]",
                casing: "lower"
            }
        }
    });
    im_email.mask(selector_email);

    $(document).mouseup(function (e) {
        var container = $(".phone_input");
        if (container.has(e.target).length === 0) {
            container.find('.input_phone').removeClass('active');
            container.find('.phone_list').removeClass('show');
        }
    });


    $(document).on('click', '.js__drop_btn', function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $(this).closest('.input_drop').find('.drop_serach_list').removeClass('show');
        } else {
            $('.js__drop_btn').removeClass('active');
            $('.drop_serach_list').removeClass('show');

            $(this).addClass('active');
            $(this).closest('.input_drop').find('.drop_serach_list').addClass('show');
        }
    });

    $('.js__search_drop').keyup(function () {
        var filter = $(this).val().trim();
        $(this).closest('.drop_serach_list')
            .find('.js_list_search .js__search_btn_point')
            .each(function () {
                if ($(this).text().search(new RegExp(filter, "i")) < 0) {
                    $(this).closest('.search_btn_point').hide();
                } else {
                    $(this).closest('.search_btn_point').show()
                }
            });

        if (filter == "") {
            $(this).closest('.search_btn_point').show()
        }
    });

    $(document).on('click', '.js__search_btn_point', function () {
        $(this).closest('.js_list_search').removeClass('active');
        $(this).addClass('active');
        const name = $(this).text().trim();
        const eu_name = $(this).attr('data-name').trim();

        $(this).closest('.input_drop').find('.input__hidden').val(eu_name);
        $(this).closest('.input_drop').find('.js__drop_btn').text(name);
        $(this).closest('.input_drop').find('.js__drop_btn').removeClass('active');
        $(this).closest('.input_drop').find('.drop_serach_list').removeClass('show');
    })

    $(document).mouseup(function (e) {
        var container = $(".input_drop");
        if (container.has(e.target).length === 0) {
            container.find('.btn_input').removeClass('active');
            container.find('.drop_serach_list').removeClass('show');
        }
    });

    $(document).on('click', '.js__valid_form_btn', function () {
        let error = 0;
        let array = {};
        let arrayContent = {};
        let arrayFiles = {};
        const mainButton = $(this);
        const load = $(this).closest('.js__triger_loader').find('.loader');

        load.addClass('js__show');
        mainButton.hide();
        const nameForm = $(this).closest('.valid_form').attr('data-name');
        $(this).closest('.valid_form').find('.send_input').each(function () {
            const name = $(this).attr('name');
            const value = $(this).val().trim()
            if ($(this).hasClass('required')) {
                if ($(this).val().trim() == "") {
                    $(this).closest('.input_wrapper').addClass('error_input');
                    $(this).removeClass('disabled')
                    error++;
                    load.removeClass('js__show');
                    mainButton.show();
                } else {
                    if ($(this).hasClass('input__hidden')) {
                        arrayContent[name] = value;
                    } else {
                        array[name] = value;
                    }
                    $(this).closest('.input_wrapper').removeClass('error_input');
                }
            } else {
                array[name] = value;
            }
        });

        if ($('.required_container').length > 0) {
            if ($('.js__file_add_hidden').length > 0) {
                $('.js__file_add_hidden').each(function () {
                    const value = $(this).val().trim();
                    const name = $(this).attr('name');

                    arrayFiles[name] = value;
                })

                $('.container_dd_wrap').removeClass('error_input');
            } else {
                $('.container_dd_wrap').addClass('error_input');
                $(this).removeClass('disabled')
                error++;
                load.removeClass('js__show');
                mainButton.show();
            }
        }

        if (array['content'] != "") {
            array['content'] = `<p style="padding: 10px 0px; display: block;border-top: 1px solid #E0E0E0;"><span style="display: block; color: #000000; font-size: 18px; line-height: 26px; font-family: Avenir_extra_bold_900, sans-serif; margin-bottom: 20px;">Message</span> <span style="display: block; color: #000000; font-size: 18px; line-height: 26px; font-family: Avenir_regular_400, sans-serif;">${array['content']}</span></p>`;
        }

        for (var content_item in arrayContent) {
            array['content'] += `<p style="padding: 10px 0px; display: block;border-top: 1px solid #E0E0E0;"><span  style="display: block; color: #000000; font-size: 18px; line-height: 26px; font-family: Avenir_extra_bold_900, sans-serif; margin-bottom: 20px;">${content_item}</span> <span style="display: block; color: #000000; font-size: 18px; line-height: 26px; font-family: Avenir_regular_400, sans-serif;">${arrayContent[content_item]}</span></p>`;
        }

        if (error == 0) {
            $.post(routes.postSend, {
                "data": array,
                "files": arrayFiles,
                "subj": nameForm,
            }, function (data) {
                if (data.status == 'ok') {
                    $('input').val('');
                    $('.saccess_modal_resume').addClass('open');
                    $('footer').after('<div class="bg__saccess"></div>');
                    load.removeClass('js__show');
                    mainButton.show();
                    setTimeout(function () {
                        location.reload()
                    }, 6000);
                }
            });
        }
    });

    $(document).on('click', '.bg__saccess, .js__close_saccess_modal', function () {
        location.reload()
    });

    function countryStart() {
        let counter = $('.js__name_country').text().trim();

        if (counter != "") {
            $('.js__phone_item').each(function () {
                let name = $(this).find('.name').text().trim();
                if (name.includes(counter)) {
                    const mask = $(this).attr('data-mask').split('#').join('9');
                    const code = $(this).attr('data-code');
                    const src = $(this).find('img').attr('src');
                    const alt = $(this).find('img').attr('alt');

                    $('.js__phone_mask img').attr({
                        'src': src,
                        'alt': alt
                    })

                    var selec = $('.input_input_phone');
                    let im_start = "";
                    if (name == 'Israel') {
                        const code = '+972'; // замените это на ваш код страны
                        const mask = `${code} ##-###-####`;

                        $('.input_input_phone').attr({
                            'placeholder': `${code} __-___-____`
                        });

                        Inputmask({
                            mask: mask,
                            definitions: {
                                '#': { // определение символа #
                                    validator: "[0-9]", // можно задать другие условия валидации
                                    cardinality: 1 // максимальная длина ввода
                                }
                            }
                        }).mask(selec);

                        $('.input_input_phone').val(9);
                    } else {
                        $('.input_input_phone').attr({
                            'placeholder': `${code} ${mask.split('9').join('_')}`
                        });
                        im_start = new Inputmask(`${code} ${mask}`);
                        im_start.mask(selec);
                    }

                }
            });
        } else {
            var selector = $('.input_input_phone');
            var im = new Inputmask(`999-9999-99999`);
            im.mask(selector);
        }
    }

});



// WEBPACK FOOTER //
// ./resources/js/components/form.js